import { Component } from '@angular/core';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'lib-archive-empty-state',
  imports: [],
  templateUrl: './archive-empty-state.component.html',
  styleUrl: './archive-empty-state.component.scss'
})
export class ArchiveEmptyStateComponent implements INoRowsOverlayAngularComp {
    agInit(): void {
    // this is necessary
  }

}
